import React from 'react'
import Navbar from './Navbar'

function Help() {
    return (
        <div>
            <Navbar/>
        </div>
    )
}

export default Help
